import styled from "styled-components";

export const TableTitle = styled.h2`
  font-weight: 500;
  font-size: 26px;
  line-height: 16px;
  margin-bottom: 20px;
`;

export const TableText = styled.p`
  font-weight: 500;
  font-size: 18px;
  line-height: 16px;
  color: var(--color);
  margin-bottom: 40px;
`;

export const TableList = styled.ul`
  list-style-type: circle;
  margin-bottom: 50px;
`;
